﻿import { ICallOracleCpqRuleArgs, IOracleCpqParams, eOracleCpqOperation } from "@models";

export class OracleCpqClient {
    constructor(private e: any) {
    }

    public createTransaction(model: IOracleCpqParams) {
        return this.e.callOracleCpq({
            operation: eOracleCpqOperation.createTransaction,
            params: model
        } as ICallOracleCpqRuleArgs);
    }

    public attachByTag(
        transactionId: string,
        documentNumber: number,
        variableName: string,
        processVarName: string,
        idQuote: number,
        idTag: number
    ) {
        return this.e.attachFileToOracle({
            source: 0,
            transactionId,
            documentNumber,
            variableName,
            processVarName,
            idQuote,
            idTag
        });
    }

    public attachMedia(
        transactionId: string,
        documentNumber: number,
        variableName: string,
        processVarName: string,
        mediaPath: string
    ) {
        return this.e.attachFileToOracle({
            source: 1,
            transactionId,
            documentNumber,
            variableName,
            processVarName,
            filePath: mediaPath
        });
    }
}
